/**
 * @file useFaqState.hook.ts
 * @path apps/website/src/features/contact/hooks/useFaqState.hook.ts
 */
import { useState, useMemo } from "react";
import { ContactService } from "../contact.service";

export const useFaqState = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  // Memoize fetching FAQs so we don't recreate the array on every render
  const faqData = useMemo(() => ContactService.getFaqs(), []);

  const handleToggle = (index: number) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return {
    activeIndex,
    faqData,
    handleToggle,
  };
};
